import { DateTime } from 'luxon';

const formatDate = (dateString) => {
  if (!dateString) return '';
  // if date is a number (unix timestamp), convert to ISO string first
  let dt;
  if (!isNaN(dateString)) {
    dt = DateTime.fromMillis(Number(dateString));
  } else {
    dt = DateTime.fromISO(dateString);
  }

  return dt.toFormat("yyyy-MM-dd hh:mm:ss.SSS a ZZZZ");
}



export default formatDate;